import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import { FaRegWindowClose } from "react-icons/fa";
import { getEquipmentUrls } from "../action";
import Loader from "../../../Components/Loader";
import { useTranslation } from "react-i18next";

const ShowMore = ({ id, onCancel }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { url_list: urlList = [] } = useSelector(
    (state) => state.transport.equipmentUrls
  );

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
    dispatch(getEquipmentUrls(id, () => setLoader(false)));
  }, []);

  return (
    <div className={styles["generic-transport__data-container__show-more"]}>
      <FaRegWindowClose
        className={
          styles["generic-transport__data-container__show-more__close"]
        }
        size={24}
        color="#a71313"
        onClick={onCancel}
      />
      <label
        className={
          styles["generic-transport__data-container__show-more__label1"]
        }
      >
        {t("Equipments")}
      </label>
      {loader ? (
        <Loader />
      ) : (
        <div
          className={
            styles["generic-transport__data-container__show-more_container"]
          }
        >
          {urlList?.map((item, key) => (
            <div
              className={
                styles["generic-transport__data-container__show-more__types"]
              }
              key={key}
            >
              <label>{item?.equipment_name}</label>
              <img
                src={item?.image_url}
                alt={item?.equipment_name}
                width={"40px"}
                height={"40px"}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShowMore;
